const { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } = require('@/enums');

module.exports = (s) => {
  return {
    channel_interface: {
      label: '媒体平台',
      type: 'select',
      props: {
        clearable: false,
        placeholder: '请选择媒体平台',
      },
      options: [
        {
          label: CHANNEL_INTERFACE_TEXT.GDT,
          value: CHANNEL_INTERFACE_TYPE.GDT,
        },
      ],
      value: CHANNEL_INTERFACE_TYPE.GDT,
    },
    filtering: {
      value: {},
      children: {
        advertiser_ids: {
          label: '广告主账户',
          type: 'select',
          props: {
            multiple: true,
            filterable: true,
          },
          options: [],
          value: '',
        },
        channel_label_id: {
          label: '媒体标签ID',
          type: 'input',
          value: '',
        },
        name: {
          label: '标签名称',
          type: 'input',
          value: '',
        },
      },
    },
  };
};
